import React, {useEffect, useState} from "react";
import styled from "styled-components";
import {currentTheme} from "../../react-themes/theme";
import {useLocale} from "../../shared-services/translate";

const theme = currentTheme();

const Certificates = (props) => {
  const {
    certificates,
    linkedList = false,
    layout,
    size = null,
    className = "",
    style
  } = props;

  const [certificateList, setCertificateList] = useState([]);
  const locale = useLocale();

  useEffect(() => {
    setCertificateList(formatCertificates(certificates));
  }, [certificates]);

  const formatCertificates = (certificates) => {
    if (!certificates || !Array.isArray(certificates)) return [];
    return certificates.map(certificate => {
      const certificateFormatted = {...certificate, showIcon: true, link: linkedList};
      if (layout === "search") {
        certificateFormatted.showIcon = false;
      }
      if (certificateFormatted?.showIcon) {
        certificateFormatted.imgSrc = certificate?.icon;
      }
      if (certificateFormatted?.link && certificate?.url) {
        certificateFormatted.url = certificate?.url;
      } else {
        certificateFormatted.link = false;
      }

      return certificateFormatted;
    });
  };

  return (
    <StyledCertificates className={`flex justify-content-flex-end align-items-flex-end ${layout}-box ${className}`}>
      {
        certificateList.map(certificate => {
          return <StyledCertificate key={certificate.id} className={`${layout}`} bgColor={certificate?.bg_color}>
            {certificate?.showIcon && <div className={`icon-wrapper  ${certificate.code} full-height`}>
              {certificate?.link && <a href={certificate.url} className={"full-height full-width flex justify-content-center align-items-center"} target="_blank" rel="noreferrer">
                <img
                  key={certificate?.id}
                  className={`quality-logo ${certificate.code} ${layout}`}
                  title={certificate.name}
                  alt={certificate.name}
                  src={certificate.imgSrc}
                />
              </a>}
              {!certificate?.link && <img
                key={certificate?.id}
                className={`quality-logo ${certificate.code} ${layout}`}
                title={certificate.name}
                alt={certificate.name}
                src={certificate.imgSrc}
              />}
            </div>}
            {!certificate?.showIcon && <div className={"name-wrapper"}>
              {certificate?.link && <a href={certificate.url} target="_blank" rel="noreferrer">{certificate?.name}</a>}
              {!certificate?.link && <span>{certificate?.name}</span>}
            </div>}
          </StyledCertificate>;
        })
      }
    </StyledCertificates>
  );
};

const StyledCertificates = styled.div`
 &.catalog-table-box {
   flex-wrap: wrap;
 }
`;

const StyledCertificate = styled.div`
  .icon-wrapper {
    background-color: ${props => props?.bgColor ? `${props.bgColor}CC` : "#FFFFFFCC"};
  }
  &.search {
    margin-left: 5px;
    background: ${props => props?.bgColor ? props.bgColor : "#F65B2D"};
    color: #ffffff;
    font-size: 14px;
    border-radius: 5px;
    font-weight: 600;
    .name-wrapper {
      padding: 2px 5px;
      color: ${theme.colors.primaryColor};
      a {
        text-decoration: none;
        color: #FFFFFF;
      }
    }
  }
  &.catalog, &.pdp {
    margin-left: 7px;
    .icon-wrapper {
      display: flex;
      align-items: center;
      justify-content: center;
      height: 45px;
      width: 45px;
      padding: 2px 4px;
      -moz-border-radius: 6px;
      -webkit-border-radius: 6px;
      border-radius: 6px;
      transition: opacity 100ms;
      overflow: hidden;

      &.best_price {
        padding: 6px;
      }

      &.kag {
        padding: 0;
      }

      &.suisse_garantie {
        padding: 5px;
        width: auto;
        border-radius: 4px;
        border: 1px solid rgba(0,0,0,0.5);
        background: rgba(255, 255, 255, 1);
        img {
          height: 100%;
          width: auto;
        }
      }
      
      img {
        width: 100%;
        height: auto;
      }
      &.msc {
        img {
          width: auto;
          height: 100%;
        }
      }
    }
  }
  
  &.catalog {
    @media (max-width: 640px) {
      .icon-wrapper {
        height: 35px;
        max-width: 40px;
      }
    }
  }
  
  &.catalog-table {
    margin-left: 3px;
    .icon-wrapper {
      img {
        max-height: 24px;
        max-width: 45px;
        border-radius: 5px;
        &.best_price {
          padding: 2px 4px;
          max-width: 40px;
        }
      }
    }
  }
`;

export default Certificates;
